"use client"
import {
  MultiSelect
} from "./chunk-2ICYBDUT.mjs";

// src/components/multi-autocomplete.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var MultiAutocomplete = mergeMultiStyle(MultiSelect)();

export {
  MultiAutocomplete
};
//# sourceMappingURL=chunk-V2V2BUVS.mjs.map